module.exports = __webpack_public_path__ + "img/0.5a79730b.jpg";